import { render, staticRenderFns } from "./NewClientRecordCategory.vue?vue&type=template&id=23f8bfa7&scoped=true"
import script from "./NewClientRecordCategory.vue?vue&type=script&lang=js"
export * from "./NewClientRecordCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f8bfa7",
  null
  
)

export default component.exports